import { useState } from 'react';
import { Link } from 'react-router-dom';
import { requestPasswordReset } from '../../services/AuthService';

function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);

    function onChangeInput(event) {
        setEmail(event.target.value);
        setError('');
    }

    function onSubmit(event) {
        event.preventDefault();
        setError('');
        setLoading(true);

        requestPasswordReset(email)
            .then(() => {
                setSuccess(true);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setError(err.response?.data || 'Erro ao solicitar recuperação de senha. Tente novamente.');
                setLoading(false);
            })
    }

    return (
        <main>
            <section className="vh-lg-100 mt-5 mt-lg-0 bg-soft d-flex align-items-center">
                <div className="container">
                    <p className="text-center">
                        <Link to="/" className="d-flex align-items-center justify-content-center">
                            <svg className="icon icon-xs me-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd"></path>
                            </svg>
                            Voltar para o login
                        </Link>
                    </p>
                    <div className="col-12 d-flex align-items-center justify-content-center">
                        <div className="bg-white shadow border-0 rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                            <div className="text-center">
                                <img src="/img/favicon/mstile-150x150.png" alt="Beholder" width={64} />
                            </div>
                            <div className="text-center text-md-center mb-4 mt-md-0">
                                <h1 className="mb-0 h3">Recuperar senha</h1>
                            </div>
                            {success ? (
                                <div className="mt-4">
                                    <div className="alert alert-success">
                                        <p className="mb-0">
                                            <strong>Email enviado!</strong>
                                        </p>
                                        <p className="mb-0 mt-2">
                                            Enviamos um link de recuperação de senha para o endereço <strong>{email}</strong>.
                                        </p>
                                        <p className="mb-0 mt-2">
                                            Verifique sua caixa de entrada e siga as instruções para redefinir sua senha.
                                        </p>
                                    </div>
                                    <div className="d-grid mt-4">
                                        <Link to="/" className="btn btn-gray-800">Voltar para o login</Link>
                                    </div>
                                </div>
                            ) : (
                                <form action="#" className="mt-4" onSubmit={onSubmit}>
                                    <div className="form-group mb-4">
                                        <label htmlFor="email">Seu e-mail</label>
                                        <div className="input-group">
                                            <span className="input-group-text" id="basic-addon1">
                                                <svg className="icon icon-xs text-gray-600" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                                                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                                                </svg>
                                            </span>
                                            <input 
                                                type="email" 
                                                className="form-control" 
                                                placeholder="exemplo@empresa.com" 
                                                id="email" 
                                                autoFocus 
                                                required 
                                                onChange={onChangeInput}
                                                value={email}
                                                disabled={loading}
                                            />
                                        </div>
                                    </div>
                                    <div className="d-grid">
                                        <button type="submit" className="btn btn-gray-800" disabled={loading}>
                                            {loading ? 'Enviando...' : 'Enviar link de recuperação'}
                                        </button>
                                    </div>
                                    {error && (
                                        <div className="alert alert-danger mt-2">{error}</div>
                                    )}
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default ForgotPassword;

